export default "__VITE_ASSET__CGTV3M$w__"